module.exports = __webpack_public_path__ + "media/damages/szkoda@2x-37925e71.png";